// Gestores (7-oct-2026). «Propietario y liquidación» (components/Gestores/OwnerSettlementPanel.vue
// y su modal OwnerFormModal.vue): la tarjeta del anuncio donde el gestor dice para quién lo lleva,
// quién cobra y cómo se le liquida.
export const ownerSettlement = {
  head: {
    title: "Eigentümer und Abrechnung",
    sub: "Wenn Sie diese Unterkunft für einen anderen Eigentümer verwalten, legen Sie fest, wer die Zahlungen erhält, wie hoch Ihre Provision ist und wie mit ihm abgerechnet wird. Darauf basieren seine Abrechnungen und Ihre Verwalter-Analyse.",
  },
  loading: "Einstellungen werden geladen…",
  loadError: {
    title: "Die Einstellungen konnten nicht geladen werden",
    text: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    retry: "Erneut versuchen",
  },
  master: {
    label: "Ich verwalte diese Unterkunft für einen Eigentümer",
    hintOff: "Die Unterkunft gehört Ihnen: Ihre Buchungen zählen als eigene Einnahmen.",
    hintOn: "Die Buchungen werden mit dem Eigentümer nach den Bedingungen unten abgerechnet.",
    kept: "Ihre bisherigen Bedingungen bleiben gespeichert, falls Sie es wieder aktivieren.",
    introTitle: "Sobald es aktiv ist:",
    intro1: "Sie wählen den Eigentümer und wer die Buchungszahlungen erhält.",
    intro2: "Sie bestimmen Ihre Provision, deren MwSt. und wer die Reinigung behält.",
    intro3: "Sie sehen sofort, wie seine Abrechnung aussieht.",
  },
  owner: {
    title: "Eigentümer",
    hint: "Die Person oder Firma, mit der Sie diese Unterkunft abrechnen.",
    placeholder: "Eigentümer auswählen",
    new: "Neuer Eigentümer",
    add: "Eigentümer hinzufügen",
    edit: "Bearbeiten",
    emptyTitle: "Sie haben noch keine Eigentümer",
    emptyText: "Fügen Sie den Eigentümer dieser Unterkunft hinzu, um mit ihm abrechnen zu können.",
    missing: "Ohne zugewiesenen Eigentümer hat die Abrechnung dieser Unterkunft keinen Empfänger.",
    pending: "Wird beim Speichern zugewiesen",
    taxId: "Steuernr.",
    addTaxId: "Steuernr. hinzufügen",
    iban: "IBAN",
    addIban: "IBAN hinzufügen",
  },
  ownerForm: {
    titleNew: "Neuer Eigentümer",
    titleEdit: "Eigentümer bearbeiten",
    sub: "Seine Daten erscheinen in den Abrechnungen der Unterkünfte, die Sie für ihn verwalten.",
    close: "Schließen",
    name: "Name oder Firma",
    taxId: "Steuernummer / USt-IdNr.",
    taxIdHint: "Seine Steuernummer, aus jedem Land.",
    taxIdDoubt: "Falls es eine spanische NIF ist, stimmt das Prüfzeichen nicht. Stammt sie aus einem anderen Land, ignorieren Sie diesen Hinweis.",
    email: "E-Mail",
    phone: "Telefon",
    iban: "IBAN",
    ibanPlaceholder: "DE00 0000 0000 0000 0000 00",
    ibanHint: "Das Konto, auf das Sie seinen Anteil überweisen.",
    ibanOk: "Gültige IBAN · {country}",
    address: "Adresse",
    notes: "Notizen",
    notesPlaceholder: "Vereinbarungen, Zahlungstag…",
    sharedNote: "Er ist auch Eigentümer von {n} weiteren Unterkunft: Die Änderungen gelten auch dort. | Er ist auch Eigentümer von {n} weiteren Unterkünften: Die Änderungen gelten überall.",
    cancel: "Abbrechen",
    save: "Eigentümer speichern",
    saving: "Wird gespeichert…",
    created: "Eigentümer angelegt",
    updated: "Eigentümer aktualisiert",
    deleted: "Eigentümer gelöscht",
    errName: "Geben Sie den Namen oder die Firma ein.",
    errEmail: "Prüfen Sie die E-Mail-Adresse: Sie scheint ungültig zu sein.",
    errIbanFormat: "Eine IBAN beginnt mit dem Ländercode und zwei Prüfziffern (DE89…).",
    errIbanCheck: "Die Prüfziffern stimmen nicht: Prüfen Sie, ob sie richtig kopiert wurde.",
    errIbanLength: "Eine IBAN ({country}) hat {expected} Zeichen, diese hat {actual}.",
    errSave: "Der Eigentümer konnte nicht gespeichert werden. Versuchen Sie es erneut.",
    errDelete: "Der Eigentümer konnte nicht gelöscht werden. Versuchen Sie es erneut.",
    delete: "Eigentümer löschen",
    deleteTitle: "{name} löschen?",
    deleteText: "Er wird aus Ihrer Eigentümerliste entfernt. Das lässt sich nicht rückgängig machen.",
    deleteConfirm: "Löschen",
    deleteBlocked: "Löschen nicht möglich: Er ist Eigentümer von {n} Unterkunft. Entfernen Sie ihn dort zuerst. | Löschen nicht möglich: Er ist Eigentümer von {n} Unterkünften. Entfernen Sie ihn zuerst aus jeder.",
    discardTitle: "Änderungen verwerfen?",
    discardText: "Was Sie zu diesem Eigentümer eingegeben haben, geht verloren.",
    discardConfirm: "Verwerfen",
    discardCancel: "Weiter bearbeiten",
  },
  units: {
    title: "Eigentümer jeder Einheit",
    hint: "Gehört eine Einheit einem anderen Eigentümer, wählen Sie ihn hier aus. Die übrigen werden mit dem Eigentümer des Inserats abgerechnet.",
    inherit: "Der des Inserats",
    summaryNone: "Alle gehören dem Eigentümer des Inserats",
    summarySome: "{n} Einheit mit anderem Eigentümer | {n} Einheiten mit anderem Eigentümer",
  },
  collection: {
    title: "Wer erhält die Buchungszahlungen?",
    hint: "Das ändert, wohin das Geld fließt, nicht was dem Eigentümer bleibt.",
    ownerLabel: "Der Eigentümer kassiert",
    ownerDesc: "Die Plattformen und Ihre Website zahlen an den Eigentümer. Danach zahlt er Ihre Honorarrechnung (und die Reinigung, falls sie Ihnen zusteht).",
    managerLabel: "Der Verwalter kassiert",
    managerDesc: "Das Geld aus den Buchungen geht an Sie. Sie behalten Ihren Teil und überweisen ihm seinen Anteil.",
    flowBooking: "Buchung",
    flowOwner: "Eigentümer",
    flowYou: "Sie",
  },
  commission: {
    title: "Ihre Provision",
    percent: "Provisionssatz",
    vat: "MwSt. auf Ihre Provision",
    base: "Berechnet auf",
    presetTotal: "Gesamtbetrag der Buchung",
    presetAccommodation: "Unterkunft ohne Reinigung",
    presetNet: "Netto nach OTA-Provision",
    presetDescNet: "{concepts}, ohne ihren Anteil an der OTA-Provision",
    presetNetClean: "Net of OTA and cleaning",
    presetDescNetClean: "What the owner keeps before your fee: the total minus the OTA, its VAT and cleaning",
    exampleBase: "Basis im Beispiel",
    custom: "Individuell",
    customize: "Manuell anpassen",
    baseLabel: "Auf welchen Betrag",
    gross: "Was der Gast zahlt",
    net: "Was nach der OTA-Provision bleibt",
    netClean: "What's left after the OTA and cleaning",
    concepts: "Welche Posten zählen",
    warnTaxes: "Abgaben sind keine Einnahmen: Darauf wird normalerweise keine Provision berechnet.",
    fixTaxes: "Abgaben entfernen",
    warnCleaning: "Sie berechnen Provision auf eine Reinigung, die Sie ohnehin behalten.",
    fixCleaning: "Reinigung entfernen",
    warnDeposit: "Die Kaution geht an den Gast zurück: Darauf wird normalerweise keine Provision berechnet.",
    fixDeposit: "Kaution entfernen",
    errPercent: "Geben Sie einen Prozentsatz zwischen 0 und 100 ein.",
    errConcepts: "Wählen Sie mindestens einen Posten.",
  },
  concepts: {
    accommodation: "Unterkunft",
    cleaning: "Reinigung",
    taxes: "Abgaben",
    extras: "Extras",
    deposit: "Kaution",
  },
  // Los mismos conceptos dentro de una frase («Base: alojamiento y extras.»): en alemán, con mayúscula
  conceptsInline: {
    accommodation: "Unterkunft",
    cleaning: "Reinigung",
    taxes: "Abgaben",
    extras: "Extras",
    deposit: "Kaution",
  },
  cleaning: {
    title: "Reinigung",
    hint: "Wer behält, was der Gast für die Reinigung zahlt?",
    owner: "Gehört dem Eigentümer",
    ownerDesc: "Bleibt in seinem Nettobetrag: Es wird nichts abgezogen.",
    manager: "Gehört Ihnen",
    managerDesc: "Sie übernehmen sie, und sie wird dem Eigentümer abgezogen.",
    charged: "Was der Gast für die Reinigung zahlt",
    fixed: "Ein fester Betrag pro Aufenthalt",
    fixedAmount: "Betrag pro Aufenthalt",
    fixedHint: "Umfasst eine Buchung mehrere Zimmer, wird der Betrag pro Zimmer einmal berechnet.",
    errAmount: "Geben Sie den festen Reinigungsbetrag pro Aufenthalt an.",
  },
  ota: {
    title: "Provision je OTA",
    moved: "Den Prozentsatz jeder OTA legen Sie in der Karte „{card}“ fest.",
    open: "„{card}“ öffnen",
  },
  example: {
    title: "Beispielabrechnung",
    sub: "Eine {channel}-Buchung über {total} mit Ihren aktuellen Bedingungen.",
    guest: "Was der Gast zahlt",
    platform: "Was {channel} behält",
    platformNote: "Die Provision: {pct}\u00a0% von {base} ({concepts}).",
    platformYours: "Ihre Prozentsätze aus „{card}“ gelten, auch wenn {channel} seine Provision übermittelt.",
    platformReal: "Übermittelt {channel} die Provision einer Buchung, wird diese verwendet.",
    platformRule: "Legen Sie den {channel}-Prozentsatz in „{card}“ fest, gilt Ihrer; sonst dessen Provision.",
    otaVat: "MwSt. auf die {channel}-Provision ({pct}\u00a0%)",
    changeIn: "In „{card}“ ändern",
    changeWhere: "Wird in „{card}“ geändert.",
    notOwner: "Was nicht dem Eigentümer gehört",
    taxes: "Abgaben und Steuern",
    taxesNote: "Sie sind keine Einnahmen des Eigentümers.",
    cleaning: "Reinigung, die Sie behalten",
    cleaningNoteCharged: "Was der Gast dafür zahlt.",
    cleaningNoteFixed: "Ihr fester Betrag pro Aufenthalt.",
    fees: "Ihre Verwaltungshonorare",
    commission: "Provision: {pct} % von {base}",
    commissionBase: "Basis: {concepts}.",
    commissionBaseNet: "Basis: {concepts}, ohne ihren Anteil an der {channel}-Provision.",
    commissionBaseNetClean: "Base: what the owner keeps after {channel}, its VAT and cleaning.",
    vat: "MwSt. auf Ihre Provision ({pct} %)",
    invoice: "Summe Ihrer Honorarrechnung",
    net: "Netto für den Eigentümer",
    netNote: "Was ihm aus dieser Buchung zusteht.",
    netNegative: "Die Abzüge übersteigen, was die Buchung einbringt.",
    splitTitle: "So werden die {total} aufgeteilt",
    legendTaxes: "Abgaben",
    legendCleaning: "Reinigung (Ihre)",
    legendFees: "Ihre Honorare",
    legendOwner: "Eigentümer",
    legendDeficit: "Fehlbetrag",
    transferTitle: "Sie überweisen {amount}",
    transferTitleTo: "Sie überweisen {amount} an {owner}",
    transferInvoice: "Und Sie stellen Ihre Honorarrechnung über {amount} aus.",
    owesTitle: "Der Eigentümer schuldet Ihnen {amount}",
    owesTitleFrom: "{owner} schuldet Ihnen {amount}",
    owesInvoice: "Es gibt nichts zu überweisen. Ihre Honorarrechnung beträgt {amount}.",
    owesHint: "In diesem Beispiel übersteigen die Abzüge, was die Buchung einbringt.",
    collectTitle: "Der Eigentümer zahlt Ihnen {amount}",
    collectTitleFrom: "{owner} zahlt Ihnen {amount}",
    collectBreakdown: "Das ist Ihre Honorarrechnung ({fees}).",
    collectBreakdownCleaning: "Ihre Honorarrechnung ({fees}) plus die Reinigung ({cleaning}).",
    ownerLoses: "Zu diesen Bedingungen verliert der Eigentümer bei dieser Buchung {amount}.",
    foot: "Beispielbeträge. Die tatsächliche Abrechnung nutzt die Aufschlüsselung jeder Buchung.",
    footNoOtaVat: "Ohne die MwSt. auf die OTA-Provision.",
  },
  footer: {
    save: "Änderungen speichern",
    saving: "Wird gespeichert…",
    unsaved: "Nicht gespeicherte Änderungen",
    saved: "Gespeichert",
    fixErrors: "Prüfen Sie die markierten Felder.",
    errSave: "Speichern fehlgeschlagen. Versuchen Sie es erneut.",
    peekLabel: "Bleibt dem Eigentümer",
    peekAria: "Beispielabrechnung ansehen: Dem Eigentümer bleiben {amount}",
  },
};
